module.exports = "<p style=\"padding-left:2em\">\nYou do not have permissions to access this content.\n</p>\n"